import validate from "/home/runner/work/ott-web-portal2/ott-web-portal2/node_modules/.pnpm/nuxt@4.0.3_@types+node@20.17.30_@vue+compiler-sfc@3.5.20_eslint@9.24.0_rollup@4.49.0_sass@1.8_w2etmzr24wz7alwc6jub3qfyoe/node_modules/nuxt/dist/pages/runtime/validate.js";
import add_45trailing_45slash_45before_45qp_45global from "/home/runner/work/ott-web-portal2/ott-web-portal2/app/middleware/add-trailing-slash-before-qp.global.ts";
import club_45global from "/home/runner/work/ott-web-portal2/ott-web-portal2/app/middleware/club.global.ts";
import skip_45auth_45page_45global from "/home/runner/work/ott-web-portal2/ott-web-portal2/app/middleware/skip-auth-page.global.ts";
import manifest_45route_45rule from "/home/runner/work/ott-web-portal2/ott-web-portal2/node_modules/.pnpm/nuxt@4.0.3_@types+node@20.17.30_@vue+compiler-sfc@3.5.20_eslint@9.24.0_rollup@4.49.0_sass@1.8_w2etmzr24wz7alwc6jub3qfyoe/node_modules/nuxt/dist/app/middleware/manifest-route-rule.js";
export const globalMiddleware = [
  validate,
  add_45trailing_45slash_45before_45qp_45global,
  club_45global,
  skip_45auth_45page_45global,
  manifest_45route_45rule
]
export const namedMiddleware = {
  auth: () => import("/home/runner/work/ott-web-portal2/ott-web-portal2/app/middleware/auth.ts")
}